/*
@license
  Expanse by Archetype Themes (https://archetypethemes.co)
  Access unminified JS in assets/theme.js

  Use this event listener to run your own JS outside of this file.
  Documentation - https://archetypethemes.co/blogs/expanse/javascript-events-for-developers

  document.addEventListener('page:loaded', function() {
    // Page has loaded and theme assets are ready
  });
*/

if (console && console.log) {
  console.log(
    "Expanse theme (" +
      theme.settings.themeVersion +
      ") by ARCHΞTYPE | Learn more at https://archetypethemes.co"
  );
}

(function () {
  "use strict";

  if (
    window.Shopify &&
    window.Shopify.theme &&
    navigator &&
    navigator.sendBeacon &&
    window.Shopify.designMode
  ) {
    navigator.sendBeacon(
      "https://api.archetypethemes.co/api/beacon",
      new URLSearchParams({
        shop: window.Shopify.shop,
        themeName:
          window.theme &&
          window.theme.settings &&
          `${window.theme.settings.themeName} v${window.theme.settings.themeVersion}`,
        role: window.Shopify.theme.role,
        route: window.location.pathname,
        themeId: window.Shopify.theme.id,
        themeStoreId: window.Shopify.theme.theme_store_id || 0,
        isThemeEditor: !!window.Shopify.designMode,
      })
    );
  }

  /*============================================================================
    Things that don't require DOM to be ready
  ==============================================================================*/

  /*============================================================================
    Things that require DOM to be ready
  ==============================================================================*/
  function DOMready(callback) {
    if (document.readyState != "loading") callback();
    else document.addEventListener("DOMContentLoaded", callback);
  }

DOMready(function () {
  document.dispatchEvent(new CustomEvent("page:loaded"));

  /* ===== A11Y FIX: aria-hidden darf keinen Tab-Fokus enthalten (Slideshow + Promo Grid) ===== */
  (function () {
    function getFocusableElements(root) {
      if (!root) return [];

      var selector =
        'a[href], area[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]';

      var els = Array.prototype.slice.call(root.querySelectorAll(selector));

      // WICHTIG: Wenn root selbst fokussierbar ist (z.B. <a aria-hidden="true">), muss es mit rein
      if (root.matches && root.matches(selector)) {
        els.unshift(root);
      }

      // Duplikate entfernen
      return Array.from(new Set(els));
    }

    function setFocusable(container, enabled) {
      var focusables = getFocusableElements(container);

      focusables.forEach(function (el) {
        var tabindex = el.getAttribute("tabindex");

        if (!enabled) {
          if (el.getAttribute("data-a11y-prev-tabindex") === null) {
            el.setAttribute("data-a11y-prev-tabindex", tabindex === null ? "" : tabindex);
          }
          el.setAttribute("tabindex", "-1");
          el.setAttribute("data-a11y-disabled-focus", "true");
        } else {
          if (el.getAttribute("data-a11y-disabled-focus") === "true") {
            var prev = el.getAttribute("data-a11y-prev-tabindex");
            el.removeAttribute("data-a11y-disabled-focus");
            el.removeAttribute("data-a11y-prev-tabindex");

            if (prev === "") el.removeAttribute("tabindex");
            else el.setAttribute("tabindex", prev);
          }
        }
      });
    }

    function apply() {
      // 1) Slideshow: ganze Slides deaktivieren wenn aria-hidden="true"
      document.querySelectorAll(".slideshow__slide[aria-hidden]").forEach(function (slide) {
        var hidden = slide.getAttribute("aria-hidden") === "true";
        setFocusable(slide, !hidden);
      });

      // 2) Promo Grid: einzelne Links/Items deaktivieren wenn aria-hidden="true"
      // (Eye-Able zeigt hier oft <a class="promo-grid__slide-link" aria-hidden="true" ...>)
      document.querySelectorAll(".promo-grid [aria-hidden]").forEach(function (el) {
        var hidden = el.getAttribute("aria-hidden") === "true";
        setFocusable(el, !hidden);
      });
    }

    // initial
    apply();

    // react to aria-hidden changes anywhere (Slideshow & Promo Grid wechseln dynamisch)
    var scheduled = false;
    var observer = new MutationObserver(function (mutations) {
      // Nur reagieren, wenn aria-hidden betroffen ist
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].type === "attributes" && mutations[i].attributeName === "aria-hidden") {
          if (!scheduled) {
            scheduled = true;
            requestAnimationFrame(function () {
              scheduled = false;
              apply();
            });
          }
          break;
        }
      }
    });

    observer.observe(document.body, {
      subtree: true,
      attributes: true,
      attributeFilter: ["aria-hidden"],
    });
  })();
  /* ===== /A11Y FIX ===== */

/* A11Y: Accessible names for empty PageFly buttons */
(function () {
  const fix = () =>
    document.querySelectorAll('button:not([aria-label]):not([aria-labelledby])')
      .forEach(btn => {
        if (!btn.textContent.trim()) {
          btn.setAttribute('aria-label', 'Slide wechseln');
        }
      });

  fix();
  new MutationObserver(fix).observe(document.body, { childList: true, subtree: true });
})();


});

})();
